import { render, staticRenderFns } from "./previewImage.vue?vue&type=template&id=34fb5642&scoped=true&"
import script from "./previewImage.vue?vue&type=script&lang=js&"
export * from "./previewImage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34fb5642",
  null
  
)

export default component.exports